

export default function HeadingServices({title, lowerTitle}) {
    return (
        <section className="page-header page-header-modern bg-primary page-header-sm">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 order-2 align-self-center text-center">
                            <h1 className="font-weight-bold text-light line-height-4">
                                <span className="text-5"> {lowerTitle}  </span>
                                
                            </h1>
                        </div>
                        <div className="col-md-12 align-self-center p-static order-1">
								<ul className="breadcrumb d-block text-center text-light">
                                    <span> {title} </span>
								</ul>
						</div>
                    </div>
                </div>
            </section>
    )
}
